import { h } from 'preact'
import { CategoryLink } from './link'
import { CategoryInfo } from '../header-navigation/Types'

const trackParentCategory = (title: string, url: string) => {
  return {
    'type': 'Category Clicked',
    'category_title': title,
    'category_url': url,
    'click_source': 'menu',
    'category_type': 'parent category'
  }
}

const gaEvents = (url: string) => {
  return {
    eventCategory: 'Homepage',
    eventAction: 'Menu clicked',
    eventLabel: {
      'Link': url
    }
  }
}

const trackCategory = (title: string, url: string) => {
  return {
    'type': 'Category Clicked',
    'category_title': title,
    'category_url': url,
    'click_source': 'menu',
    'category_type': 'category'
  }
}

interface Props {
  key: string,
  title: string,
  url: string,
  categories: Array<CategoryInfo>,
}

export default ({ title, url, categories = [] }: Props) => {
  return <li>
    <CategoryLink
      track={trackParentCategory(title, url)}
      gaEvents={gaEvents(url)}
      href={url}
      title={title}
    >
      <strong>{title}</strong>
    </CategoryLink>

    {categories.map(category => {
      return <CategoryLink
        href={category.url}
        track={trackCategory(category.title, category.url)}
        gaEvents={gaEvents(category.url)}
        title={category.title}
        topicsCount={category.topicCount}
      >
        {category.title}
      </CategoryLink>
    })}
  </li>
}
